/* eslint-disable prettier/prettier */
import localize from '../../localize';

const isNewTransform = (items) => {
  let trueObj = items.find((o) => o.value === 'true');
  if (!trueObj) {
    return items;
  }

  trueObj.label = localize('is_new') || 'Is new';

  items = [trueObj];
  return items;
};

export default [
  {
    key: 'tjanst',
    position: 'top',
    attribute: 'taxonomies.Tjänst',
    copyKey: 'typeOfHome',
    copySelect: 'chooseType',
  },
  {
    key: 'lan',
    position: 'top',
    attribute: 'taxonomies.Län',
    copyKey: 'region',
    copySelect: 'selectRegion',
  },
  {
    key: 'kommun',
    position: 'top',
    attribute: 'taxonomies.kommun',
    copyKey: 'municipality',
    copySelect: 'selectMunicipality',
  },
  {
    key: 'search',
    position: 'top',
    copyKey: 'searchTitle',
    copyPlaceholder: 'searchTitle',
  },
  {
    key: 'livsstil',
    position: 'panel',
    attribute: 'taxonomies.Livsstil',
    copyKey: 'lifestyle',
  },
  {
    key: 'sswsDriftsform',
    position: 'panel',
    attribute: 'metadata.ssws_driftsform',
    copyKey: 'operatingMode',
  },
  {
    key: 'sswsIsNew',
    position: 'panel',
    attribute: 'metadata.ssws_is-new',
    copyKey: 'isNew',
    transform: isNewTransform,
  },
];
